import React from "react";
import "./activityid.css";

function Activityid() {
  return (
    <div className="container mainactivityid">
      <div className="row">
        {/* Activity id and name section */}
        <div className="col-6">
          <form action="">
            <input
              type="text"
              padding-bottom
              placeholder="Activity ID"
              className="activityid"
            />{" "}
            <br />
            <input
              tye="text"
              placeholder="Activity Name"
              className="activityid"
            />
          </form>
        </div>
        <div className="col-3">
          <form action="">
            <input type="text" placeholder="Zone" className="activityid" />
            <input type="date" placeholder="Date" className="activityid" />
          </form>
        </div>
        <div className="col-3">
          <form action="">
            <input type="text" placeholder="Subzone" className="activityid" />
            <input
              type="date"
              placeholder="Executed Date"
              className="activityid"
            />
          </form>
        </div>
        {/* End Activity id and name section */}
      </div>
    </div>
  );
}

export default Activityid;
